<template>
  <div>
    <v-autocomplete
      v-bind="$attrs"
      label="Kapcsolat"
      :error-messages="errorMessages"
      :value="connection_id"
      :items="connections"
      item-text="name"
      item-value="element_id"
      filled
      :value-comparator="$config.comparators.isEqual"
      append-outer-icon="mdi-plus"
      @click:append-outer="showConnectionDialog = true"
      @change="updateConnectionId"></v-autocomplete>

    <connection-dialog v-model="showConnectionDialog" @save="input" />
  </div>
</template>

<script>
import ConnectionDialog from '@/components/ConnectionDialog.vue';

export default {
  inheritAttrs: false,

  components: {
    ConnectionDialog,
  },

  props: ['connection_id', 'errors', 'errorMessages'],

  data() {
    return {
      showConnectionDialog: false,
      connections: [],
    }
  },

  async mounted() {
    await this.fetchConnections();
  },

  methods: {
    async fetchConnections() {
      const response = await this.$http.get('connections/list');
      this.connections = response.connections;
    },

    async input(connection) {
      await this.fetchConnections();
      this.updateConnectionId(connection.element_id);
    },

    async updateConnectionId(connectionId) {
      this.$emit('update:connection_id', connectionId);
    },
  },
}
</script>